import React, { Component } from 'react';
import { Context } from 'context';

import Folder from 'editor/sidebar/folders/folder/Folder';

import styles from './Folders.module.scss';
import Group from "editor/sidebar/folders/group/Group";
import Map from "editor/sidebar/folders/map/Map";

class Folders extends Component {
    static contextType = Context;

    render() {

        let folderStructure = this.context.folderStructure;

        // Filter by map.favourited or map.swModified
        if(this.props.tab === 1){
            folderStructure = folderStructure.filter((folder) => { return folder.codeNames.some((map) => { return map.favourited || map.swModified }) });
            folderStructure = folderStructure.map((folder) => { return {
                ...folder,
                codeNames: folder.codeNames.filter((map) => { return map.favourited || map.swModified })
            }});
        }

        // Filter folders by search term
        const search = this.props.search.toLowerCase();

        folderStructure = folderStructure.reduce((newFolderStructure, folder) => {
            const title = folder.title.toLowerCase();
            const titleDescription = folder.titleDescription.toLowerCase();
            const groupName = folder.groupName.toLowerCase();

            const folderMatches = title.includes(search) || titleDescription.includes(search) || groupName.includes(search)

            if (folderMatches) return [...newFolderStructure, folder];

            const matchingMaps = folder.codeNames.filter((map) => {
                const title = map.title.toLowerCase();
                const titleDescription = map.titleDescription.toLowerCase();
                const mapName = map.mapName.toLowerCase();

                return title.includes(search) || titleDescription.includes(search) || mapName.includes(search);
            })

            if (matchingMaps.length < 1) return newFolderStructure;

            return [...newFolderStructure, {...folder, codeNames: matchingMaps}]
        }, []);

        const sortedFolderStructure = folderStructure.sort((a, b) => {
            if (b.groupName === "ungrouped") return -1;
            if (a.groupName < b.groupName) return -1;
            if (a.groupName > b.groupName) return 1;
            return 0;
        });

        const groupedFolderStructure = sortedFolderStructure.reduce((prev, current) => {
            if (!prev[current.groupName]) prev[current.groupName] = [];
            prev[current.groupName].push(current);
            return prev;
        }, {});

        return (
            <div className={styles.folders} data-hint={this.props.tab === 1 ? this.context.text.hints.myMaps : this.context.text.hints.allMaps}>
                {Object.values(groupedFolderStructure).map(group =>
                    <Group groupName={group[0].groupName}>
                        { group.map((folder, idx) =>
                            <Folder key={idx} folder={folder}>
                                {folder.codeNames.map((map, idx) =>
                                    <Map key={idx} map={map}/>
                                )}
                            </Folder>
                        )}
                    </Group>
                )}
            </div>
        )        
    }
}

export default Folders;
